var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProductEnvironment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44077 4.61536V5.44613L0.923076 5.44613L0.923076 11.169H6V11.9998H0.461538C0.20664 11.9998 3.85138e-07 11.8138 3.85138e-07 11.5844L0 5.03074C0 4.80134 0.20664 4.61536 0.461538 4.61536H5.44077Z",
    fill: "#1B1F1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17379 0C6.48033 0 7.61478 0.727935 8.18432 1.7957C8.75629 0.99961 9.69715 0.48 10.7608 0.48H12.4612V1.68C12.4612 3.40313 11.0474 4.8 9.30334 4.8H8.57459V7.2H11.0037V11.04C11.0037 11.5702 10.5687 12 10.0321 12H6.14546C5.60882 12 5.17379 11.5702 5.17379 11.04V9.12V7.2H7.60293L7.60295 5.76H6.63131C4.20213 5.76 3.23047 2.81568 3.23047 0.96V0H5.17379ZM10.0321 8.16H6.14546V11.04H10.0321V8.16ZM11.4896 1.44H10.7608C9.55344 1.44 8.57459 2.40707 8.57459 3.6V3.84H9.30334C10.5108 3.84 11.4896 2.87293 11.4896 1.68V1.44ZM5.17379 0.96H4.20213C4.20213 2.28548 4.51508 4.46923 6.63131 4.8H7.60295C7.60295 2.4 7.11712 0.96 5.17379 0.96Z",
    fill: "#1B1F1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04608 6V6.73846C3.04608 7.35022 3.542 7.84615 4.15377 7.84615C4.76552 7.84615 5.26146 7.35022 5.26146 6.73846V6H5.99992V6.73846C5.99992 7.75805 5.17337 8.58461 4.15377 8.58461C3.13417 8.58461 2.30762 7.75805 2.30762 6.73846V6H3.04608Z",
    fill: "#1B1F1E"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProductEnvironment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Product-Environment.327a6a9b.svg";
export { ForwardRef as ReactComponent };